import {
	getUniqueFilterSprints,
	getSprintStatesCategories,
	getExternalSprintsForDependencyReport,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/dependencies';

import { getSprintsAndTeamsByIssueSources } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/sprints';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { OwnProps, StateProps } from './types';

export default createStructuredSelector<State, OwnProps, StateProps>({
	sprintFilter: getUniqueFilterSprints,
	externalSprints: getExternalSprintsForDependencyReport,
	sprintsAndTeams: getSprintsAndTeamsByIssueSources,
	sprintStatesCategories: getSprintStatesCategories,
});
